import { Country } from '@tiendanube/common/src/enums';
import { PARTNER_APPS_ROUTES } from './partnersAppsRoutes';

export const getNuvemEnvioExternalSaleOrdersRoute = (
  country: Country,
): string => {
  const routesByCountry = {
    [Country.AR]: PARTNER_APPS_ROUTES.nuvemenvioExternalSaleOrdersAr,
    [Country.BR]: PARTNER_APPS_ROUTES.nuvemenvioExternalSaleOrders,
    [Country.MX]: PARTNER_APPS_ROUTES.nuvemenvioExternalSaleOrdersMx,
  } as const;

  return routesByCountry[country];
};
